import React from 'react';
import LegalPage from './LegalPage';

const CookiePolicyPage = ({ onRequestDemo, onRequestQuote }) => {
  const intro = [
    'This Cookie Policy explains how CTRL Systems, Inc. ("CTRL") uses cookies and similar technologies on <a href="https://www.ctrlsys.com" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">ctrlsys.com</a> and <a href="https://www.ctrl.aero" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">ctrl.aero</a>.',
  ];

  const sections = [
    {
      number: '1',
      title: 'Definitions',
      blocks: [
        { type: 'p', text: 'Cookies are small text files placed on your device when you visit a website. We may also use pixels, tags, web beacons, local storage, and scripts (collectively, "cookies").' },
      ],
    },
    {
      number: '2',
      title: 'Categories of Cookies Used',
      blocks: [
        { type: 'sub', number: '2.1', title: 'Essential Cookies', blocks: [
          { type: 'p', text: 'Necessary for website functionality, security, and order processing (e.g., session cookies, authentication cookies, fraud-prevention cookies). These cannot be disabled without affecting site functionality.' },
        ]},
        { type: 'sub', number: '2.2', title: 'Analytics Cookies', blocks: [
          { type: 'p', text: 'Help us understand website usage (e.g., Google Analytics). Measured metrics include page views, user flow, bounce rates, and conversions.' },
        ]},
        { type: 'sub', number: '2.3', title: 'Advertising Cookies', blocks: [
          { type: 'p', text: 'Measure and optimize advertising (e.g., Google Ads, LinkedIn Insight Tag, Meta Pixel). May track page visits, form submissions, case-study downloads, quote requests, and purchases.' },
        ]},
        { type: 'sub', number: '2.4', title: 'Retargeting Cookies', blocks: [
          { type: 'p', text: 'Allow us and our advertising partners to show relevant ads to prior visitors across LinkedIn, Facebook, Instagram, and Google properties.' },
        ]},
      ],
    },
    {
      number: '3',
      title: 'Third-Party Cookies',
      blocks: [
        { type: 'p', text: 'Third-party providers may place cookies through our Websites, including Google, LinkedIn, Meta, Stripe, Odoo, Twilio, and EmoryDay. These parties collect information under their own privacy policies.' },
      ],
    },
    {
      number: '4',
      title: 'Managing Cookies',
      blocks: [
        { type: 'p', text: 'You may control cookies through your browser or device settings and via industry opt-out tools such as the <a href="https://optout.networkadvertising.org/" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">Network Advertising Initiative</a>, the <a href="https://optout.aboutads.info/" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">Digital Advertising Alliance</a>, and <a href="https://youradchoices.com/" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">YourAdChoices</a>. You may also revisit your preferences via the <em>Cookie Settings</em> link in our footer. Blocking cookies may affect website functionality.' },
      ],
    },
    {
      number: '5',
      title: 'Consent',
      blocks: [
        { type: 'p', text: 'Where required by law, we obtain your consent before placing non-essential cookies. By continuing to use the Websites you consent to our use of cookies as described herein, except where applicable law requires separate consent.' },
      ],
    },
    {
      number: '6',
      title: 'Changes to this Policy',
      blocks: [
        { type: 'p', text: 'We may update this Cookie Policy periodically. Changes become effective upon posting.' },
      ],
    },
    {
      number: '7',
      title: 'Contact',
      blocks: [
        { type: 'address', lines: [
          '<strong>CTRL Systems, Inc.</strong>',
          '1004 Littlestown Pike, Suite H · Westminster, MD 21157 · United States',
          '<a href="mailto:privacy@ctrlsys.com" class="text-blue-600 hover:underline">privacy@ctrlsys.com</a>',
        ]},
      ],
    },
  ];

  return (
    <LegalPage
      title="Cookie Policy"
      lastUpdated="July 1, 2026"
      intro={intro}
      sections={sections}
      onRequestDemo={onRequestDemo}
      onRequestQuote={onRequestQuote}
    />
  );
};

export default CookiePolicyPage;
